<template>
  <div class="preview-mask" @click.self="close">
    <!-- 关闭 -->
    <div class="close-btn" @click.stop="close"><i class="el-icon-close"></i></div>
    <!-- 左 -->
    <div class="left-btn" @click.stop="prev"><i class="el-icon-arrow-left"></i></div>
    <!-- 右 -->
    <div class="right-btn" @click.stop="next"><i class="el-icon-arrow-right"></i></div>
    <div class="preview-content" @click.self="close">
      <!-- 图片 -->
      <div v-if="current.type === 'image'" class="image-wrapper" @click.stop>
        <div ref="imageStage" class="image-stage">
          <img :key="current.id" ref="image" :src="current.image" class="preview-image" @load="initPanzoom" />
        </div>
      </div>
      <!-- 视频 -->
      <div v-else class="video-wrapper" @click.stop>
        <video
          ref="video"
          controls
          autoplay
          class="video-player"
          :poster="current.image"
          @error="handleVideoError"
          @timeupdate="saveVideoTime"
        >
          <source :src="current.url" type="video/mp4" />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import Panzoom from '@panzoom/panzoom/dist/panzoom'
export default {
  props: {
    list: Array,
    index: Number
  },

  data() {
    return {
      currentIndex: this.index,
      progressMap: {},
      panzoom: null
    }
  },

  computed: {
    current() {
      return this.list[this.currentIndex]
    }
  },

  mounted() {
    document.body.style.overflow = 'hidden'
    this.loadProgressMap()
    this.initViewer()
  },

  beforeDestroy() {
    document.body.style.overflow = ''
    this.saveProgressMap()
    this.destroyPanzoom()
  },

  methods: {
    initViewer() {
      this.$nextTick(() => {
        if (this.current.type === 'image') {
          const img = this.$refs.image
          if (img && img.complete && img.naturalWidth > 0) {
            this.initPanzoom()
          }
        } else {
          this.restoreVideoTime()
        }
      })
    },

    initPanzoom() {
      this.destroyPanzoom()
      const stage = this.$refs.imageStage
      if (!stage) return
      this.panzoom = Panzoom(stage, {
        minScale: 1,
        maxScale: 4,
        startScale: 1,
        contain: 'outside',
        panOnlyWhenZoomed: true
      })
      stage.parentElement.addEventListener('wheel', this.handleWheel, {
        passive: false
      })
    },

    handleWheel(e) {
      e.preventDefault()
      if (!this.panzoom) return
      const direction = e.deltaY < 0 ? 1 : -1
      const scale = this.panzoom.getScale() * Math.exp((direction * 0.3) / 3)
      this.panzoom.zoom(scale, { animate: false })
    },

    destroyPanzoom() {
      if (!this.panzoom) return
      const stage = this.$refs.imageStage
      if (stage && stage.parentElement) {
        stage.parentElement.removeEventListener('wheel', this.handleWheel)
      }
      this.panzoom.destroy()
      this.panzoom = null
    },

    close() {
      this.saveCurrentVideo()
      this.destroyPanzoom()
      setTimeout(() => {
        this.$emit('close')
      }, 300)
    },

    prev() {
      if (this.currentIndex === 0) {
        return
      }
      this.saveCurrentVideo()
      this.destroyPanzoom()
      this.currentIndex--
      this.initViewer()
    },

    next() {
      if (this.currentIndex >= this.list.length - 1) {
        return
      }
      this.saveCurrentVideo()
      this.destroyPanzoom()
      this.currentIndex++
      this.initViewer()
    },

    saveVideoTime() {
      if (this.current.type !== 'video') {
        return
      }
      const video = this.$refs.video
      console.log('saveVideoTime', video.currentTime)
      this.$set(this.progressMap, this.current.id, video.currentTime)
    },

    saveCurrentVideo() {
      if (this.current.type !== 'video') {
        return
      }
      const video = this.$refs.video
      if (!video) return
      video.pause()
      // console.log('saveCurrentVideo', video.currentTime)
      this.$set(this.progressMap, this.current.id, video.currentTime)
      this.saveProgressMap()
      // video.pause()
    },

    restoreVideoTime() {
      if (this.current.type !== 'video') {
        return
      }
      this.$nextTick(() => {
        const video = this.$refs.video
        if (!video) return
        video.onloadedmetadata = () => {
          const time = this.progressMap[this.current.id] || 0
          video.currentTime = time
          video.addEventListener('click', () => {
            video.play().catch((e) => console.warn('Play failed:', e))
          })
        }
      })
    },
    handleVideoError(e) {
      console.error('Video error:', e.target.error)
      // 可弹出提示：“视频格式不支持，请尝试刷新或更换浏览器”
    },
    loadProgressMap() {
      try {
        const saved = localStorage.getItem('historyMediaProgressMap')
        if (!saved) return
        const parsed = JSON.parse(saved)
        if (parsed && typeof parsed === 'object') {
          this.progressMap = parsed
        }
      } catch (err) {
        console.warn('加载视频进度失败', err)
      }
    },

    saveProgressMap() {
      try {
        localStorage.setItem('historyMediaProgressMap', JSON.stringify(this.progressMap))
      } catch (err) {
        console.warn('保存视频进度失败', err)
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.preview-mask {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-content {
  width: 100vw;
  height: 100vh;
  //padding: 12vh 6vw;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-wrapper {
  width: 80vw;
  height: 60vh;
  // max-width: 720px;
  // max-height: 760px;
  overflow: hidden;
  box-sizing: border-box;
  border: 6px solid #fff;
  border-radius: 4px;
  background: #848383;
  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.3);
  touch-action: none;
}

.image-stage {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-image {
  display: block;
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  user-select: none;
  cursor: grab;
  touch-action: none;
}

.preview-image:active {
  cursor: grabbing;
}

.video-wrapper {
  width: 80vw;
  height: 60vh;
  background: #fff;
  padding: 6px;
  box-sizing: border-box;
}

.video-player {
  width: 100%;
  height: 100%;
}

.close-btn {
  position: fixed;
  right: 8vw;
  top: 13vh;
  width: 5.3458vw;
  height: 5.3458vw;
  border-radius: 50%;
  background: #fff;
  font-size: 3.0375vw;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10000;
}

.left-btn,
.right-btn {
  position: fixed;
  top: 50%;

  transform: translateY(-50%);
  width: 7.3458vw;
  height: 7.3458vw;
  border-radius: 50%;
  background: #fff;
  font-size: 2.7375vw;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10000;
}

.left-btn {
  left: 1.0833vw;
}

.right-btn {
  right: 1.0833vw;
}
</style>
